<template>
    <v-card class="main-card">
        <v-card-title>
            <div class="main_title">
                <h6>Módulos de ayuda</h6>
                <button @click="showCreateFeatureModal = true" class="faccess_button">Agregar</button>
            </div>
        </v-card-title>
        <div class="feature_list">
            <v-card v-for="feature of features" :key="feature.id" @click="showFeatureQuestion(feature)"
                class="feature_card">
                <div style="display: flex; width: 100%; text-overflow: ellipsis;">
                    <video v-if="feature.video" :src="feature.video" class="feature-logo" muted autoplay
                        loop playsinline />
                    <img v-else-if="feature.logo" :src="feature.logo" class="feature-logo" />

                    <div class="feature_title">
                        {{ feature.title }}</div>
                </div>
                <v-card-actions class="card_actions">
                    <button class="btn btn-ghost" @click="openEditFeatureModal($event, feature)">Editar</button>
                    <button class="btn btn-danger" @click="removeFeature($event, feature)">Eliminar</button>
                </v-card-actions>
            </v-card>
        </div>
        <v-dialog v-model="showCreateFeatureModal" max-width="520" persistent>
            <v-card class="create-feature-card">
                <!-- Header -->
                <v-card-title class="dialog-header">
                    <div>
                        <h3 class="dialog-title">Crear nueva funcionalidad</h3>
                        <p class="dialog-subtitle">
                            Configura el módulo y su imagen representativa
                        </p>
                    </div>

                    <v-btn icon variant="text" @click="closeDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider />

                <!-- Content -->
                <form @submit.prevent="createFeature">
                    <v-card-text class="dialog-content">
                        <v-text-field v-model="newFeatureModal.title" label="Nombre del módulo" variant="outlined"
                            density="comfortable" hide-details v-validate="'required'" name="feature_title"
                            :error="errors.has('feature_title')" />


                        <div class="upload-container" :class="{ 'upload-error': errors.has('feature_media_file') }">
                            <video v-if="isVideoMedia(newFeatureModal.mediaFile)" :src="newFeatureModal.preview"
                                class="upload-preview" muted autoplay loop playsinline />
                            <img v-else-if="newFeatureModal.preview" :src="newFeatureModal.preview" class="upload-preview" />

                            <template v-else>
                                <upload-icon class="upload-icon" />
                                <div class="upload-text">
                                    <strong>Subir logo o video del módulo</strong>
                                    <span>SVG, PNG, JPG o MP4</span>
                                </div>
                            </template>

                            <input type="file" class="upload-input" name="feature_media_file" ref="featureMediaFile"
                                accept=".svg,.png,.jpg,.jpeg,.mp4"
                                v-validate="'required|mimes:image/svg+xml,image/png,image/jpeg,video/mp4'"
                                @change="onMediaFileSelected" />
                        </div>

                    </v-card-text>

                    <v-divider />

                    <!-- Actions -->
                    <v-card-actions type="button" class="dialog-actions">
                        <v-btn variant="text" @click="closeDialog">
                            Cancelar
                        </v-btn>

                        <v-btn type="button" color="primary" :disabled="!newFeatureModal.title || !newFeatureModal.mediaFile"
                            @click="createFeature">
                            Crear módulo
                        </v-btn>
                    </v-card-actions>
                </form>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showEditModal" max-width="520" persistent>
            <v-card class="create-feature-card">
                <!-- Header -->
                <v-card-title class="dialog-header">
                    <div>
                        <h3 class="dialog-title">Editar funcionalidad</h3>
                        <p class="dialog-subtitle">
                            Actualiza el nombre o el logo del módulo
                        </p>
                    </div>

                    <v-btn icon variant="text" @click="closeEditDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider />

                <form @submit.prevent="updateFeature">
                    <v-card-text class="dialog-content">
                        <v-text-field v-model="editFeatureModal.title" label="Nombre del módulo" variant="outlined"
                            density="comfortable" hide-details />

                        <div class="upload-container">
                            <video v-if="editFeatureModal.mediaFile ? isVideoMedia(editFeatureModal.mediaFile) : !!editFeatureModal.video"
                                :src="editFeatureModal.preview" class="upload-preview" muted autoplay loop playsinline />
                            <img v-else-if="editFeatureModal.preview" :src="editFeatureModal.preview"
                                class="upload-preview" />

                            <template v-else>
                                <upload-icon class="upload-icon" />
                                <div class="upload-text">
                                    <strong>Actualizar logo o video</strong>
                                    <span>SVG, PNG, JPG o MP4</span>
                                </div>
                            </template>

                            <input type="file" class="upload-input" ref="editFeatureMediaFile"
                                accept=".svg,.png,.jpg,.jpeg,.mp4"
                                @change="onEditMediaFileSelected" />
                        </div>
                    </v-card-text>

                    <v-divider />

                    <v-card-actions class="dialog-actions">
                        <v-btn variant="text" @click="closeEditDialog">
                            Cancelar
                        </v-btn>

                        <v-btn color="primary" @click="updateFeature">
                            Guardar cambios
                        </v-btn>
                    </v-card-actions>
                </form>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showDeleteModal" max-width="420" persistent>
            <v-card class="create-feature-card">
                <v-card-title class="dialog-header">
                    <div>
                        <h3 class="dialog-title">Eliminar módulo</h3>
                        <p class="dialog-subtitle">
                            Esta acción no se puede deshacer
                        </p>
                    </div>

                    <v-btn icon variant="text" @click="closeDeleteDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider />

                <v-card-text class="dialog-content">
                    ¿Seguro que deseas eliminar el módulo
                    <strong>{{ deleteFeatureModal.title }}</strong>?
                </v-card-text>

                <v-divider />

                <v-card-actions class="dialog-actions">
                    <v-btn variant="text" @click="closeDeleteDialog">
                        Cancelar
                    </v-btn>

                    <v-btn color="error" @click="confirmRemoveFeature">
                        Eliminar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </v-card>
</template>
<script>

export default {
    data() {
        return {
            features: [],
            showCreateFeatureModal: false,
            newFeatureModal: {
                title: '',
                mediaFile: null,
                preview: null,
            },
            showEditModal: false,
            editFeatureModal: {
                id: null,
                title: '',
                mediaFile: null,
                video: null,
                preview: null,
            },
            showDeleteModal: false,
            deleteFeatureModal: {
                id: null,
                title: '',
            },
        }
    },
    methods: {
        async initialize() {
            await this.getFeatures();
        },
        async getFeatures() {
            const comapanyId = this.getCompany().id;
            if (!comapanyId) return;
            try {
                const response = await this.$http.get('company_features', { params: { company_id: comapanyId } });
                this.features = response.data.data.map(cf => ({
                    title: cf.attributes.name,
                    logo: (cf.attributes.logo && cf.attributes.logo.url) || null,
                    video: cf.attributes.video || null,
                    feature_id: cf.id
                }));
                console.log('Fetched features:', this.features);
            } catch (error) {
                console.error('Error fetching features:', error);
            }
        },
        onMediaFileSelected(event) {
            const file = event.target.files[0]
            if (!file) return

            this.newFeatureModal.mediaFile = file

            // Preview
            const reader = new FileReader()
            reader.onload = e => {
                this.newFeatureModal.preview = e.target.result
            }
            reader.readAsDataURL(file)
        },

        closeDialog() {
            this.showCreateFeatureModal = false
            this.resetCreateFeatureModal();
            this.$refs.featureMediaFile.value = null;

        },

        resetCreateFeatureModal() {
            this.newFeatureModal = {
                title: '',
                mediaFile: null,
                preview: null,
            }
        },
        async createFeature() {
            const isValid = await this.$validator.validateAll()
            if (!isValid) return

            const data = {
                name: this.newFeatureModal.title,
                code: new Date().getTime() + '' + this.newFeatureModal.title.toUpperCase().replace(/\s+/g, '_'),
            }

            if (this.isVideoMedia(this.newFeatureModal.mediaFile)) {
                data.video = await this.uploadVideoToS3(this.newFeatureModal.mediaFile)
            } else {
                data.logo = await this.fileToBase64(this.newFeatureModal.mediaFile)
            }
            console.log(data);
            try {
                const feature = await this.$http.post('features', { data: this.encrypt(data).toString() }, {
                    headers:
                    {
                        "X-Device-ID": this.getDeviceId(),
                        "Authorization": 'Bearer ' + this.getUserToken()
                    },
                });

                await this.$http.post('company_features', {
                    data: this.encrypt({
                        company_id: this.getCompany().id,
                        feature_id: feature.data.data.id,
                    }).toString()
                }, {
                    headers:
                    {
                        "X-Device-ID": this.getDeviceId(),
                        "Authorization": 'Bearer ' + this.getUserToken()
                    },
                });
                this.initialize();
                this.closeDialog();
            } catch (error) {
                console.error('Error creating feature:', error);
            }
        },
        async fileToBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
                reader.readAsDataURL(file);
            });
        },

        openEditFeatureModal(event, feature) {
            event.stopPropagation();
            this.editFeatureModal = {
                id: feature.feature_id,
                title: feature.title,
                mediaFile: null,
                video: feature.video || null,
                preview: feature.video || feature.logo,
            }
            this.showEditModal = true
        },

        onEditMediaFileSelected(event) {
            const file = event.target.files[0]
            if (!file) return

            this.editFeatureModal.mediaFile = file

            const reader = new FileReader()
            reader.onload = e => {
                this.editFeatureModal.preview = e.target.result
            }
            reader.readAsDataURL(file)
        },

        closeEditDialog() {
            this.showEditModal = false
            this.editFeatureModal = {
                id: null,
                title: '',
                mediaFile: null,
                video: null,
                preview: null,
            }
            if (this.$refs.editFeatureMediaFile) {
                this.$refs.editFeatureMediaFile.value = null
            }
        },

        async updateFeature() {
            const data = {
                name: this.editFeatureModal.title,
            }

            if (this.editFeatureModal.mediaFile) {
                if (this.isVideoMedia(this.editFeatureModal.mediaFile)) {
                    data.video = await this.uploadVideoToS3(this.editFeatureModal.mediaFile)
                } else {
                    data.logo = await this.fileToBase64(this.editFeatureModal.mediaFile)
                    if (this.editFeatureModal.video) data.video = null
                }
            }

            try {
                await this.$http.put(
                    `features/${this.editFeatureModal.id}`,
                    { data: this.encrypt(data).toString() },
                    {
                        headers: {
                            "X-Device-ID": this.getDeviceId(),
                            "Authorization": 'Bearer ' + this.getUserToken()
                        }
                    }
                )

                await this.initialize()
                this.closeEditDialog()
            } catch (error) {
                console.error('Error updating feature:', error)
            }
        },
        async removeFeature(event, feature) {
            event.stopPropagation();

            this.deleteFeatureModal = {
                id: feature.feature_id,
                title: feature.title,
            }

            this.showDeleteModal = true
        },

        closeDeleteDialog() {
            this.showDeleteModal = false
            this.deleteFeatureModal = {
                id: null,
                title: '',
            }
        },

        async confirmRemoveFeature() {
            try {
                await this.$http.delete(
                  `company_features/${this.deleteFeatureModal.id}?company_id=${this.getCompany().id}`,{
                     headers: {
                        "X-Device-ID": this.getDeviceId(),
                        "Authorization": 'Bearer ' + this.getUserToken()
                     }
                  }
                )
                
                await this.$http.delete(
                    `features/${this.deleteFeatureModal.id}`,
                    {
                        headers: {
                            "X-Device-ID": this.getDeviceId(),
                            "Authorization": 'Bearer ' + this.getUserToken()
                        }
                    }
                )

                await this.initialize()
                this.closeDeleteDialog()
            } catch (error) {
                console.error('Error deleting feature:', error)
            }
        },
        showFeatureQuestion(feature) {
            this.$router.push({
                name: 'feature_questions',
                params: { id: feature.feature_id }
            });
        },
        async uploadVideoToS3(file) {
            const response = await this.$http.post('features/presign', null, {
                params: {
                    filename: file.name,
                    content_type: file.type,
                    company_id: this.getCompany().id
                },
                headers:
                {
                  "Authorization": 'Bearer ' + this.getUserToken(),
                  "X-Device-ID": this.getDeviceId(),
                },
            })

            const body = response.data
            const payload = body.data ? (body.data.attributes || body.data) : body

            const s3Response = await fetch(payload.presigned_url, {
                method: 'PUT',
                headers: { 'Content-Type': file.type },
                body: file,
            })

            if (!s3Response.ok) {
                throw new Error('Error subiendo el video a S3')
            }

            return payload.public_url
        },
        isVideoMedia(media) {
            if (!media) return false
            if (media.type) return media.type.startsWith('video/')
            return /\.(mp4|webm|ogg|mov)$/i.test(media)
        },


    },
    mounted() {
        this.initialize();
    }
}
</script>

<style scoped>
.upload-error {
    border-color: #d32f2f !important;
}


.create-feature-card {
    border-radius: 16px;
}

.dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 1.25rem 1.5rem;
}

.dialog-title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
}

.dialog-subtitle {
    margin: 0;
    font-size: 0.85rem;
    color: #666;
}

.dialog-content {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    padding: 1.5rem;
}

/* Upload */
.upload-container {
    position: relative;
    border: 2px dashed #ccc;
    border-radius: 12px;
    padding: 1.25rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    cursor: pointer;
    transition: border-color 0.2s ease, background 0.2s ease;
}

.upload-container:hover {
    border-color: #6750a4;
    background: #6750a410;
}

.upload-icon {
    font-size: 2rem;
    color: #6750a4;
}

.upload-text {
    display: flex;
    flex-direction: column;
    font-size: 0.85rem;
}

.upload-text span {
    color: #777;
}

.upload-preview {
    width: 100%;
    max-height: 180px;
    object-fit: contain;
    border-radius: 8px;
    display: block;
}

/* input invisible */
.upload-input {
    position: absolute;
    inset: 0;
    opacity: 0;
    cursor: pointer;
}

/* Actions */
.dialog-actions {
    padding: 1rem 1.5rem;
    gap: 0.5rem;
}


.upload_file_field {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.feature-logo {
    width: 120px;
    height: 120px;

    min-width: 120px;
    min-height: 120px;

    max-width: 120px;
    max-height: 120px;

    object-fit: contain;
    display: block;
}

.main-card {
    border-radius: 1rem;
}

.main_title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.feature_list {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    padding: 1rem;
    gap: 1rem;
}

.feature_card {
    padding: 0.5rem;
    background: #3c3c3c1c;
}

.feature_title {
    margin-left: 1rem;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 1.2rem;
    overflow: hidden;
    text-overflow: ellipsis;
}

.card_actions {
    display: flex;
    justify-content: end;
    gap: 0.5rem;
}

.btn {
    padding: 0.4rem 0.8rem;
    border-radius: 0.5rem;
    font-size: 0.85rem;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: background 0.2s ease, transform 0.1s ease;
}

/* Agregar */
.btn-primary {
    background: #6750a4;
    color: white;
}

.btn-primary:hover {
    background: #7b62c2;
}

/* Editar */
.btn-ghost {
    background: transparent;
    color: #444;
}

.btn-ghost:hover {
    background: #00000010;
}

/* Eliminar */
.btn-danger {
    background: #f34343;
    color: white;
}

.btn-danger:hover {
    background: #d62424;
}

.btn:active {
    transform: scale(0.96);
}

.upload_file_icon {
    width: 120px;
    height: 120px;
    color: rgb(41, 169, 255);
}
</style>



// WEBPACK FOOTER //
// src/components/views/feautres/FeatureIndex.vue